export default __webpack_public_path__ + "static/media/010-night.f1648177.svg";